import { render, staticRenderFns } from "./do-action.vue?vue&type=template&id=5d671aac&scoped=true"
import script from "./do-action.vue?vue&type=script&lang=js"
export * from "./do-action.vue?vue&type=script&lang=js"
import style0 from "./do-action.vue?vue&type=style&index=0&id=5d671aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d671aac",
  null
  
)

export default component.exports